import { render, staticRenderFns } from "./DetailQuote.vue?vue&type=template&id=5a29ac3b&scoped=true&"
import script from "./DetailQuote.vue?vue&type=script&lang=js&"
export * from "./DetailQuote.vue?vue&type=script&lang=js&"
import style0 from "./DetailQuote.vue?vue&type=style&index=0&id=5a29ac3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a29ac3b",
  null
  
)

export default component.exports